module.exports = __webpack_public_path__ + "static/pandajumperset-edce827911c0f42c4f035d1a0c2830f4.jpeg";